import React from "react";
import Skeleton from "react-loading-skeleton";
import { CourseCardContainer } from "../../style/components/CourseCard.jsx";

const CourseCardSkeleton = () => {
  return (
    <CourseCardContainer>
      <div className="course-image">
        <Skeleton height={180} width="100%" />
      </div>

      <div className="course-content">
        <h2 className="course-title">
          <Skeleton height={24} width="80%" />
        </h2>
        <p className="course-description">
          <Skeleton count={2} />
        </p>
        <div className="course-meta">
          <div className="category-tag">
            <Skeleton width={80} height={24} />
          </div>
        </div>
      </div>

      <div className="course-actions">
        <Skeleton width={100} height={36} />
        <Skeleton circle width={36} height={36} />
      </div>
    </CourseCardContainer>
  );
};

export default CourseCardSkeleton;